module.exports = __webpack_public_path__ + "img/dic.c1269c48.svg";